<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 132 127"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
        <path d="M80,15c20,0,37,17,37,37S100,89,80,89,43,72,43,52,60,15,80,15Z" transform="translate(-14 -15)"/>
        <path d="M80,97.7c-31.5,0-63,14.8-66,44.3H146C143,112.5,111.5,97.8,80,97.7Zm8,11-1.8,2.7a7.42,7.42,0,0,0-1.1,5l1.4,11.7-3.4,9.4a4.43,4.43,0,0,1-3.2,1.8,2.94,2.94,0,0,1-2.7-1.8l-3.4-9.4,1.4-11.7a7.61,7.61,0,0,0-1.1-5l-1.8-2.7a5,5,0,0,1,4.6-7.5h6.9a5.58,5.58,0,0,1,3.9,1.6A5.66,5.66,0,0,1,88,108.7Z"
              transform="translate(-14 -15)"/>
    </svg>
</template>

<script>
    export default {
        name: "OwnersListIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
